(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["backorder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bbb-stock-notice')) {
    customElements.define('bbb-stock-notice', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.requestId = 0;
        this.timer = setTimeout(() => this.start(), 0);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller.abort();
        this.requestId += 1;
      }

      start() {
        this.scope = this.closest('.js-quickbuy, .cc-featured-product, .shopify-section');
        if (!this.scope) return;
        this.cartQuantity = Number(this.dataset.cartQuantity) || 0;
        const options = { signal: this.controller.signal };
        const update = () => this.update();
        this.scope.addEventListener('input', update, options);
        this.scope.addEventListener('change', update, options);
        this.scope.addEventListener('on:variant:change', update, options);
        ['on:cart:add', 'on:line-item:change', 'on:cart:change', 'on:bfcache:load-restore'].forEach(name => {
          document.addEventListener(name, () => this.refreshCart(), options);
        });
        window.addEventListener('pageshow', () => this.refreshCart(), options);
        window.addEventListener('focus', () => this.refreshCart(), options);
        this.update();
        this.refreshCart();
      }

      update() {
        const form = this.scope.querySelector('.js-product-form');
        const id = form?.elements.namedItem('id')?.value;
        const input = form?.elements.namedItem('quantity');
        const quantity = input ? Number(input.value) : 1;
        const stock = Number(this.dataset.stock);
        const eligible = this.dataset.eligible === 'true' && String(id) === this.dataset.variant;
        const show = eligible && Number.isFinite(quantity) && quantity > 0 && quantity + this.cartQuantity > stock;
        this.hidden = !show;
        this.querySelector('[data-empty]').hidden = !show || stock > 0;
        this.querySelector('[data-excess]').hidden = !show || stock <= 0;
      }

      async refreshCart() {
        const requestId = ++this.requestId;
        try {
          const response = await fetch(this.dataset.cartUrl, {
            cache: 'no-store', signal: this.controller.signal
          });
          if (!response.ok) return;
          const cart = await response.json();
          if (!this.isConnected || requestId !== this.requestId) return;
          this.cartQuantity = cart.items.reduce((sum, item) =>
            sum + (String(item.variant_id) === this.dataset.variant ? item.quantity : 0), 0);
          this.update();
        } catch (error) {
          if (error.name !== 'AbortError') this.update();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    (() => {
    const originalPrices = new WeakMap();

    function updateDealerPrice(info) {
      const priceBox = info.querySelector('.product-info__price .price');
      const table = priceBox?.querySelector('.dealer-tier-pricing');
      const price = priceBox?.querySelector('.price__current .js-value');
      const quantity = info.querySelector('product-form [name="quantity"]');
      if (!table || !price || !quantity) return;

      const count = Number(quantity.value);
      if (!originalPrices.has(price)) originalPrices.set(price, price.innerHTML);

      let selectedPrice = null;
      let selectedMinimum = 0;
      table.querySelectorAll('li').forEach((row) => {
        const minimum = parseInt(row.firstElementChild?.textContent, 10);
        if (minimum <= count && minimum > selectedMinimum) {
          selectedMinimum = minimum;
          selectedPrice = row.lastElementChild.textContent.trim();
                  }
      });

      if (selectedPrice) {
        price.textContent = selectedPrice;
      } else {
        price.innerHTML = originalPrices.get(price);
      }
    }

    function updateAll() {
      document.querySelectorAll('.product-info').forEach(updateDealerPrice);
    }

    function quantityChanged(event) {
      if (!event.target.matches('[name="quantity"]')) return;
      const info = event.target.closest('.product-info');
      if (info) updateDealerPrice(info);
    }

    document.addEventListener('input', quantityChanged);
    document.addEventListener('change', quantityChanged);
    document.addEventListener('on:variant:change', () => requestAnimationFrame(updateAll));
    document.addEventListener('shopify:section:load', updateAll);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAll, { once: true });
    } else {
      updateAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
